import React from "react";
import { Link } from "react-router-dom";
import logo from '../images/logo_white.png'
import logo_white_beta from '../images/logo_white_beta.png'
import facebook from '../images/facebook.png'
import twitter from '../images/twitter.png'
import instagram from '../images/instagram.png'



function Footer() {

    const handleTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

    function ScrollTop() {
        window.scrollTo(0, 0);
    }

    return (
        <>
            <div className="bg-brown hidden">
                {/* <div className="lg:max-w-[1440px] lg:mx-auto px-8 lg:px-32 pt-20 pb-5 hidden md:block">
                    <div className="flex flex-row justify-between items-start relative">
                        <div className="flex flex-col max-w-[320px]">
                            <Link to="/home"><img className="w-[177px] h-[94px]" src={logo_white_beta} alt="L&L_Logo" /></Link>

                            <p className="text-white font-[Lato] text-[16px] font-semibold leading-[21.5px] tracking-[0.40px] mt-7">
                                For over 15 years, Lands and Lands has been offering comprehensive and trusted real estate services for Individuals, Organizations, Government and Industry across Tamilnadu.
                            </p>

                            <hr className="text-font-brown mt-7 mb-5 w-[105px] border-t-2" />

                            <div className="font-[lato] text-[#BABABA] text-[14px] font-normal">
                                <p className="leading-[19.5px] tracking-[0.4px] pb-[1.5px]">No.46, Kerala Club Road</p>
                                <p className="leading-[19.5px] tracking-[0.4px] pb-[1.5px]">ATT Colony, Coimbatore-641018</p>
                                <p className="leading-[19.5px] tracking-[0.4px] pb-[1.5px]">+91 90251 34134</p>
                                <p className="leading-[19.5px] tracking-[0.4px] pb-[1.5px]">info@landsandlands.com</p>
                            </div>

                        </div>

                        <div className="flex flex-wrap w-[60%] justify-around relative ">
                            <div className="flex flex-col gap-y-9">
                                <Link to="/about"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">About</p></Link>
                                <Link to="/residential"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Residential</p></Link>
                                <Link to="/industries"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Industries</p></Link>
                            </div>

                            <div className="flex flex-col gap-y-9">
                                <Link to="/liaison"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Liaison</p></Link>
                                <Link to="/registration"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Registration</p></Link>
                                <Link to="/digital-survey"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Digital Survey</p></Link>
                            </div>

                            <div className="flex flex-col gap-y-9">
                                <Link to="/comingsoon"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Blog</p></Link>
                                <Link to="/comingsoon"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Career</p></Link>
                                <Link to="/contact"><p className="font-alibaba text-[#D1D4D6] text-[20px] leading-[21.5px] tracking-[0.4px] ">Contact</p></Link>
                            </div>
                        </div>

                        <div className="absolute bottom-0 right-12">
                            <div className="flex flex-row items-center">
                                <a href="https://www.twitter.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px] mx-3" src={twitter} alt="twitter_icon" /></a>
                                <a href="https://www.instagram.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px] mx-3" src={instagram} alt="instagram" /></a>
                                <a href="https://www.facebook.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px] mx-3" src={facebook} alt="facebook" /></a>
                            </div>
                        </div>

                    </div>
                    <hr className="w-full mx-auto text-[#575857] border-t-2 mt-6" />
                    <p className="text-white text-[16px] font-normal leading-[21.5px] tracking-[0.4px] py-[16px] text-center">&#169; 2023 Lands & Lands</p>
                </div> */}





                {/*Footer Mobile Version */}

                <div className="bg-brown pt-16 pb-5 px-12 block md:hidden ">
                    <img className="w-[197px] h-[94px] mx-0 sm:mx-auto" src={logo} alt="L&L_Logo" />
                    <p className="text-white font-[Lato] text-[17px] font-semibold leading-[21.5px] tracking-[0.40px] mt-12 text-left">For over 15 years, Lands and Lands has been offering comprehensive and trusted real estate services for Individuals, Organizations, Government and Industry across Tamil Nadu.</p>
                    {/* <p className="font-[Lato] text-[16px] text-white font-semibold leading-5 tracking-[0.4px] w-[265px] h-[119px] my-7">Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur. </p> */}

                    <hr className="text-font-brown w-[60%] border-t3 mt-7" />

                    <div className="font-[lato] text-dark-grey text-[16px] font-normal leading-[21.5px] tracking-[0.4px] text-left my-7">
                        <p className="pt-1">No.46, Kerala Club Road</p>
                        <p className="pt-1">ATT Colony, Coimbatore </p>
                        <p className="pt-1">+91 90251 34134 </p>
                        <p className="pt-1">info@landsandlands.com </p>
                    </div>

                    <hr className="text-font-brown border-t" />

                    <div className="flex flex-row justify-left items-center gap-x-16">
                        <div>
                            <li onClick={handleTop}><Link to="/about"><p className="footer-list">About</p></Link></li>
                            <li onClick={handleTop}><Link to="/residential"><p className="footer-list">Residential</p></Link></li>
                            <li onClick={handleTop}><Link to="/industries"><p className="footer-list">Industries</p></Link></li>
                        </div>
                        <div className="">
                            <li onClick={handleTop}><Link to="/liaison"><p className="footer-list">Liaison</p></Link></li>
                            <a href="https://registrations.landsandlands.com"><li><p className="footer-list ">Registration</p></li></a>
                            {/* <li onClick={ScrollTop}><Link to ="contact"><p className="footer-list">Contact US</p></Link></li> */}
                        </div>
                    </div>

                    <hr className="text-font-brown my-7" />

                    <div className="flex flex-row justify-center">
                        <a href="https://www.twitter.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px] mx-3" src={twitter} alt="twitter_icon" /></a>
                        <a href="https://www.instagram.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px] mx-3" src={instagram} alt="instagram" /></a>
                        <a href="https://www.facebook.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px] mx-3" src={facebook} alt="facebook" /></a>
                    </div>

                    <p className="mt-5 font-[Lato] text-center text-white">&#169; 2024 Lands and Lands</p>
                </div>
            </div>

            {/* New Footer Prithiv*/}
            <div className="bg-brown h-fit relative !z-20">

                <div className="max-w-[1200px] mx-auto pt-[70px] flex flex-col sm:flex-row justify-between gap-6 px-4">

                    {/* First div */}
                    <div className="sm:max-w-[310px]">
                        <img className="w-[197px]" src={logo} alt="L&L_logo" />

                        <p className="text-[16px] font-alibaba text-white font-normal leading-[23px] mt-[25px]">
                            For over 15 years, Lands and Lands has been offering comprehensive and trusted real estate services for Individuals, Organizations, Government and Industry across Tamilnadu.
                        </p>

                        <hr className="text-font-brown mt-7 mb-5 w-[105px] border-t-2" />

                        <div className="font-[lato] text-dark-grey text-[16px] font-normal leading-[21.5px] tracking-[0.4px] text-left">
                            <a href="https://maps.app.goo.gl/SyfbzPRcaduWPCvN7" target="_blank"><p className="pt-1">No.46, Kerala Club Road</p></a>
                            <a href="https://maps.app.goo.gl/SyfbzPRcaduWPCvN7" target="_blank"><p className="pt-1">ATT Colony, Coimbatore </p></a>
                            <a href="tel:9025134134"><p className="pt-1">+91 90251 34134 </p></a>
                            <a href="mailto:info@landsandlands.com"><p className="pt-1">info@landsandlands.com </p></a>
                        </div>
                    </div>

                    {/* Second div */}
                    <div className="relative sm:w-[570px] grid grid-cols-2 lg:grid-flow-col justify-between gap-9 p-6">

                        <div className="flex flex-col gap-y-9 font-alibaba text-[#D1D4D6] text-[18px] leading-[21.5px] tracking-[0.4px]">
                            <Link to="/about" onClick={handleTop}><p>About</p></Link>
                            <Link to="/residential" onClick={handleTop}><p>Residential</p></Link>
                            <Link to="/industries" onClick={handleTop}><p>Industries</p></Link>
                            <Link to="/office-space-for-rent-in-coimbatore" onClick={handleTop}><p>Commercial</p></Link>
                        </div>

                        <div className="flex flex-col gap-y-9 font-alibaba text-[#D1D4D6] text-[18px] leading-[21.5px] tracking-[0.4px] " >
                            <Link to="/liaison" onClick={handleTop}><p>Liaison</p></Link>
                            <Link to="/registration" onClick={handleTop}><p>Registration</p></Link>
                            <Link to="/digitalsurvey" onClick={handleTop}><p>Digital Survey</p></Link>
                        </div>

                        <div className="flex flex-col gap-y-9 font-alibaba text-[#D1D4D6] text-[18px] leading-[21.5px] tracking-[0.4px]">
                            <Link to="/comingsoon" onClick={handleTop}><p>Blog</p></Link>
                            <Link to="/comingsoon"onClick={handleTop}><p>Career</p></Link>
                            <Link to="/contact" onClick={handleTop}><p>Contact</p></Link>
                            <Link to="/privacypolicy" onClick={handleTop}><p>Privacy Policy</p></Link>
                        </div>

                        {/* Absolute socials */}
                        <div className="absolute bottom-0 right-12">
                            <div className="flex flex-row items-center gap-[24px]">
                                <a href="https://www.twitter.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px]" src={twitter} alt="twitter_icon" /></a>
                                <a href="https://www.instagram.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px]" src={instagram} alt="instagram" /></a>
                                <a href="https://www.facebook.com/landsandlands/" target="_blank"><img className="w-[21px] h-[21px]" src={facebook} alt="facebook" /></a>
                            </div>
                        </div>
                    </div>

                    

                </div>

                <hr className="max-w-[1200px] mx-auto text-[#575857] border-t-2 mt-[58px]" />
                <p className="font-alibaba text-white text-[16px] font-normal leading-[21.5px] tracking-[0.4px] py-[18px] text-center">&#169; 2025 LANDS&LANDS. <span className="font-normals">All rights reserved.</span></p>


            </div>

        </>
    )
}

export default Footer;